export const breakpoints = {
  phoneUpperBoundary: 600,
  tabletPortrait: 880,
  tabletLandscape: 1024,
  smallDesktop: 1025,
  desktop: 1200,
  largeDesktop: 1366,
  extraLargeDesktop: 1800,
}
